/**
 * Adresa média changelogu — **jediné místo, kde se skládá**.
 *
 * Tahle cesta se nedá ověřit guardem ``fe-api-paths``: ten kontroluje
 * jen volání přes ``apiFetch``, kdežto médium se načítá přes
 * ``<img src>`` / ``<video src>``. Překlep v ní projde lintem,
 * typecheckem i celou gate a projeví se až tím, že na produkci
 * nejsou v článcích obrázky.
 *
 * Přesně to se stalo: frontend stavěl ``/api/v1/public-assets/…``,
 * server mountuje ``/api/v1/public/assets/…``. Proto je konstanta
 * jedna a hlídá ji test proti OpenAPI snapshotu
 * (``tests/changelogAssetUrl.test.ts``).
 */

/** Musí odpovídat routě ``serve_changelog_media`` v ``routers/public_assets.py``. */
export const CHANGELOG_ASSET_PREFIX = "/api/v1/public/assets/changelog";

export function changelogAssetUrl(key: string): string {
  return `${CHANGELOG_ASSET_PREFIX}/${key}`;
}
